import React from "react";
import Modal from "../Modal/Modal";
import strings from "../../helpers/Localization";
import ProgressBarImport from "../ProgressBar/ProgressBarImport";

const UploadManager = ({ open, inProgressFiles, doneFiles, queueFiles }) => {
    const convertBytes = (fileSize) => {
        let size = fileSize / 1000;
        if (size > 1000) {
            size = parseInt(size / 1000);
            size += " MB";
        }
        else {
            size = parseInt(size);
            size += " KB";
        }

        return size;
    };

    return (
        <Modal
            open={open} hideClose
            title={strings.UploadManager}
            icon={"upload"}
            fields={[{
                type: "custom",
                child: <div className="verticalFlexContainer" style={{ height: "auto" }}>
                    {
                        doneFiles.map((el, index) => {
                            return (
                                <div className="horizontalFlexContainer" key={index} style={{ gap: "10px", margin: 0 }} id="doneFiles-dialog-description">
                                    <p className="name-file">{el.name}</p>
                                    <span className="span-file"></span>
                                    <p className="size">{convertBytes(el.size)}</p>
                                    <p className="status">{strings.uploadDownloaded}</p>
                                </div>
                            );

                        })
                    }
                    {
                        inProgressFiles.map((el, index) => {
                            return (
                                <div className="horizontalFlexContainer" key={index} style={{ gap: "10px", margin: 0 }} id="inProgressFiles-dialog-description">
                                    <p className="name-file">{el.name}</p>
                                    <span className="span-file"></span>
                                    <p className="size" style={{ marginLeft: "-70px" }}>{convertBytes(el.size)}</p>
                                    <div style={{ width: "auto", height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <ProgressBarImport />
                                    </div>
                                </div>
                            );

                        })
                    }
                    {
                        queueFiles.map((el, index) => {
                            return (
                                <div className="horizontalFlexContainer" key={index} style={{ gap: "10px", margin: 0 }} id="queueFiles-dialog-description">
                                    <p className="name-file">{el.name}</p>
                                    <span className="span-file"></span>
                                    <p className="size">{convertBytes(el.size)}</p>
                                    <p className="status">{strings.uploadWaiting}</p>
                                </div>
                            );

                        })
                    }
                </div>
            }]}
        />
    );
};

export default UploadManager;
